import {useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import SettingsHeader from "../SettingsHeader";
import {ShopTabs} from "../ShopTabs";
import {useShopTabsShopsQuery} from "../../../Queries";
import {WholeSaleCategoryList} from "../../shop/wholesale/components/WholeSaleCategoryList";
import {WholeSaleActivate} from "../../shop/wholesale/components/WholeSaleActivate";
import Button from "@mui/material/Button";
import {Paper} from "@mui/material";
import useWholeSaleCreator from "../../shop/wholesale/hooks/useWholeSaleCreator";
import AddIcon from "@mui/icons-material/Add";

export const WholeSaleSettingsPath = (brandId: string, shopId: string) => {
   return "/brands/" + brandId + "/settings/wholesale/" + shopId
}

export const WholeSaleSettingsEditPath = (brandHouseId: string, shopId: string, categoryId: string) => {
   return "/brands/" + brandHouseId + "/settings/wholesale/" + shopId + "/" + categoryId
}

export const WholeSaleSettings = () => {
   const {brandHouseId, shopId} = useParams<{ brandHouseId: string, shopId: string }>();
   const navigate = useNavigate();
   const wholeSaleCreate = useWholeSaleCreator();

   const {data: shopsData} = useShopTabsShopsQuery({
      variables: {brandHouseId: brandHouseId!},
      skip: !brandHouseId
   });

   // Auto-navigate to first shop when no shopId in URL
   useEffect(() => {
      if (!shopId && shopsData?.ShopMany?.length) {
         navigate(WholeSaleSettingsPath(brandHouseId, shopsData.ShopMany[0]._id), {replace: true});
      }
   }, [shopId, shopsData, brandHouseId, navigate]);

   const handleChange = (newValue: string) => {
      navigate(WholeSaleSettingsPath(brandHouseId, newValue));
   };

   const onAddCategory = async () => {
      if (!shopId) return;
      let newCategoryId = await wholeSaleCreate(shopId);
      navigate(WholeSaleSettingsEditPath(brandHouseId, shopId, newCategoryId));
   }

   if (!shopId) {
      return null;
   }

   return <div>
      <SettingsHeader title={"Categories"}>
         <WholeSaleActivate/>
         <Button variant={"outlined"} startIcon={<AddIcon/>} onClick={onAddCategory}>Create category</Button>
      </SettingsHeader>
      <ShopTabs
         hideDefault={true}
         activeId={shopId}
         brandHouseId={brandHouseId}
         onChange={handleChange}
         renderDefault={() => <div/>}
         renderShop={() => <Paper sx={{padding: '20px', marginBottom: '20px'}}><WholeSaleCategoryList/></Paper>}
      />
   </div>
}
